import Api from '../../../shared/Api';
import { BrokerAgreement } from './types';

export class BrokerAgreementApi {
    static async getBrokerAgreement(
        brokerAgentId: number,
        brokerFirmId: number,
        planOnly: boolean
    ): Promise<BrokerAgreement> {
        return new Api().get(
            `/views/orders/broker-agreement?brokerAgentId=${brokerAgentId}&brokerFirmId=${brokerFirmId}&planOnly=${planOnly}`
        );
    }
}
